export default __webpack_public_path__ + "static/scams-hub-apr-june-2024-hero-f29be24ff3e482201e7fa1af1d83cdb6.webp";